// views/tutorial.js
import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./tutorial.css";
import "./common-view.css";

const Tutorial = () => {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(1);

  const steps = useMemo(() => [
    {
      id: 1,
      navTitle: t("tutorial.steps.1.navTitle"),
      title: t("tutorial.steps.1.title"),
      description: t("tutorial.steps.1.description"),
      bullets: t("tutorial.steps.1.bullets", { returnObjects: true }) || [],
      videoPlaceholder: t("tutorial.steps.1.videoPlaceholder"),
      actionText: t("tutorial.steps.1.actionText"),
      actionLink: "/dashboard?tab=business"
    },
    {
      id: 2,
      navTitle: t("tutorial.steps.2.navTitle"),
      title: t("tutorial.steps.2.title"),
      description: t("tutorial.steps.2.description"),
      bullets: t("tutorial.steps.2.bullets", { returnObjects: true }) || [],
      videoPlaceholder: t("tutorial.steps.2.videoPlaceholder"),
      actionText: t("tutorial.steps.2.actionText"),
      actionLink: "/dashboard?tab=catalog"
    },
    {
      id: 3,
      navTitle: t("tutorial.steps.3.navTitle"),
      title: t("tutorial.steps.3.title"),
      description: t("tutorial.steps.3.description"),
      bullets: t("tutorial.steps.3.bullets", { returnObjects: true }) || [],
      videoPlaceholder: t("tutorial.steps.3.videoPlaceholder"),
      actionText: t("tutorial.steps.3.actionText"),
      actionLink: "/dashboard?tab=whatsapp"
    }
  ], [t]);

  const currentContent = steps.find(s => s.id === activeStep) || steps[0];

  return (
    <div className="tutorial-page">
      <div className="tutorial-container">

        {/* Left Sidebar: Progress Navigation */}
        <div className="tutorial-sidebar">
          <h2 className="tutorial-nav-title">{t("tutorial.welcomeGuide")}</h2>
          <div className="tutorial-steps-list">
            {steps.map((step) => (
              <button 
                key={step.id}
                className={`tutorial-step-btn ${activeStep === step.id ? 'active' : ''}`}
                onClick={() => setActiveStep(step.id)}
              >
                <div className="step-number">{step.id}</div>
                <div className="step-name">{step.navTitle}</div>
              </button>
            ))}
          </div>

          <div className="tutorial-sidebar-footer">
            <a className="btn-back-home full-width" href="/">
              <span className="btn-back-icon">←</span>
              <span>{t("tutorial.backHome")}</span>
            </a>
          </div>
        </div>

        {/* Right Content Area: Video & Instructions */}
        <div className="tutorial-content">
          <div className="tutorial-header">
            <h1>{currentContent.title}</h1>
            <p className="tutorial-subtitle">{currentContent.description}</p>
          </div>

          <div className="tutorial-video-placeholder">
            <div className="video-mockup">
              {currentContent.videoPlaceholder}
            </div>
          </div>

          <div className="tutorial-instructions">
            <h3>{t("tutorial.whatYouNeedToDo")}</h3>
            <ul>
              {Array.isArray(currentContent.bullets) &&
                currentContent.bullets.map((bullet, idx) => (
                  <li key={idx}>{bullet}</li>
                ))}
            </ul>
          </div>

          <div className="tutorial-actions">
            <a className="btn-primary" href={currentContent.actionLink}>
              {currentContent.actionText} →
            </a>
            {activeStep < 3 && (
              <button
                className="btn-secondary"
                onClick={() => setActiveStep(activeStep + 1)}
              >
                {t("tutorial.nextLesson")}
              </button>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Tutorial;